import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import FilterReversionReload from 'views/management/reversionReload/filterReversionReload'; // Importing filter component
import TableReversionReload from 'views/management/reversionReload/tableReversionReload'; // Importing table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the reversion reload view.
 * @extends JetView
 */
export default class reversionReloadView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration

        // Toolbar configuration
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Pager template
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from config
                },
            ],
        };

        // Left panel configuration
        const left = {
            Width: 250, // Fixed width for the left panel
            responsiveCell: false,
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left panel
                    css: theme, // Applying the current theme
                    elements: [
                        {
                            view: 'label', // Label for the title
                            label: _('Reversión de Recarga'), // Localized title
                            width: 300, // Width of the label
                        },
                    ],
                },
                FilterReversionReload, // Including the filter component
                TableReversionReload, // Including the table component
                toolbar, // Including the toolbar
            ],
        };

        webix.ui.fullScreen(); // Setting the UI to full screen mode

        // Returning the main layout configuration
        return {
            type: 'wide', // Layout type
            responsive: true, // Enabling responsive design
            css: 'out', // CSS class for the main container
            cols: [left, { view: 'resizer' }], // Columns layout with a resizer
        };
    }
}

// FILE DOCUMENTED
